module.exports = __webpack_public_path__ + "img/FR30006.53b2fd5e.png";